/* eslint-disable import/first */

let langs = {};

/** English */
import en from "./en.json";
langs["en"] = en;

/** Traditional Chinese */
import zh from "./zh.json";
langs["zh"] = zh;

/** Traditional Chinese */
import zhTW from "./zh_TW.json";
langs["zh-TW"] = zhTW;

export default langs;
